/* EDG Traditional Builder — guided handoff from dog profile to native Shopify variant picker. */
(function () {
  'use strict';

  const $ = (root, sel) => root.querySelector(sel);
  const $$ = (root, sel) => Array.from(root.querySelectorAll(sel));
  const pretty = n => Number(Number(n).toFixed(3)).toString();

  function queryParams() { return new URLSearchParams(window.location.search || ''); }
  function isGuided() { return queryParams().get('edg_guided') === '1'; }
  function show(el, yes) { if (el) el.hidden = !yes; }
  function selectButton(button, container) {
    if (!container) return;
    $$((container), 'button').forEach(el => el.classList.toggle('is-selected', el === button));
  }
  function setText(root, sel, text) { const el = $(root, sel); if (el) el.textContent = text || ''; }

  function nativeContainer(optionHandle) {
    const selector = '[data-option-name="' + optionHandle + '"]';
    return document.querySelector('.variant-selects-main ' + selector) || document.querySelector(selector);
  }

  function applyNative(optionHandle, value) {
    const container = nativeContainer(optionHandle);
    if (!container) return false;
    const radio = Array.from(container.querySelectorAll('input[type="radio"]')).find(el => el.value === value);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    const select = container.querySelector('select');
    if (select) {
      const index = Array.from(select.options).findIndex(option => option.value === value || option.textContent.trim() === value);
      if (index >= 0) {
        select.selectedIndex = index;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  function nativeSelected(optionHandle) {
    const container = nativeContainer(optionHandle);
    if (!container) return '';
    const radio = container.querySelector('input[type="radio"]:checked');
    if (radio) return radio.value;
    const select = container.querySelector('select');
    return select ? select.value : '';
  }

  function preferredProductForm(root) {
    const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).filter(form => !root.contains(form));
    return forms.find(form => String(form.getAttribute('id') || '').indexOf('product-form-') === 0 && form.querySelector('input[name="id"]')) || forms.find(form => form.querySelector('input[name="id"]')) || null;
  }

  function setStatus(root, message, state) {
    const el = $(root, '[data-status]');
    if (!el) return;
    el.textContent = message || '';
    if (state) el.dataset.state = state; else delete el.dataset.state;
  }

  function parseRange(label) {
    const match = String(label || '').match(/([0-9]+(?:\.[0-9]+)?)\s*-\s*([0-9]+(?:\.[0-9]+)?)/);
    return match ? { min: Number(match[1]), max: Number(match[2]) } : null;
  }

  function recommendedSize(root, neck) {
    const buttons = $$(root, '[data-size-choice]');
    const matches = buttons.map(button => ({ button, range: parseRange(button.dataset.nativeValue) }))
      .filter(item => item.range && neck >= item.range.min && neck <= item.range.max)
      .sort((a, b) => (b.range.min - a.range.min) || (b.range.max - a.range.max));
    if (matches.length) return { button: matches[0].button, overlap: matches.length > 1, custom: false };
    const custom = buttons.find(button => /custom/i.test(button.dataset.nativeValue || ''));
    return custom ? { button: custom, overlap: false, custom: true } : null;
  }

  function setStep(root, key, state) {
    const step = $(root, '[data-step="' + key + '"]');
    if (!step) return;
    step.classList.remove('is-active', 'is-complete', 'is-locked');
    step.classList.add('is-' + state);
    const header = $(step, '[data-edit-step]');
    if (header) {
      header.disabled = state === 'locked';
      header.setAttribute('aria-expanded', state === 'active' ? 'true' : 'false');
    }
    const progress = $(root, '[data-progress="' + key + '"]');
    if (progress) {
      progress.classList.toggle('is-active', state === 'active');
      progress.classList.toggle('is-complete', state === 'complete');
    }
  }

  function focusActiveStep(root) {
    window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
      const step = $(root, '[data-step].is-active');
      if (!step) return;
      const header = $(step, '[data-edit-step]') || step;
      const sticky = document.querySelector('.section-header.is-sticky');
      const offset = 16 + (sticky ? Math.max(0, sticky.getBoundingClientRect().height) : 0);
      const top = Math.max(0, window.scrollY + header.getBoundingClientRect().top - offset);
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      window.scrollTo({ top, behavior });
      if (header.focus) header.focus({ preventScroll: true });
    }));
  }

  function activateStep(root, key) {
    const order = ['fit', 'construction', 'color', 'addons', 'review'];
    const index = order.indexOf(key);
    order.forEach((name, i) => {
      if (i < index) setStep(root, name, 'complete');
      else if (i === index) setStep(root, name, 'active');
      else setStep(root, name, 'locked');
    });
  }

  function fiWebbingSummary(root, value, width) {
    const model = String(value || '').replace(/\s*[-–—]\s*(?:3\/4|1)\s*inch\b/ig, '').trim();
    return [model, width ? (root.dataset.webbingLabel || '[width]').replace('[width]', width) : ''].filter(Boolean).join(' · ');
  }

  function constructionWidth(root) {
    if (root.dataset.productFamily === 'traditional-standard') return root.dataset.webbingWidth || '';
    if (/Series 2/i.test(root.dataset.nativeFiSeries || '')) return root.dataset.webbingWidth || '';
    const value = root.dataset.nativeFiSeries || '';
    if (/3\/4 inch/i.test(value)) return '3/4 inch';
    if (/1 inch/i.test(value)) return '1 inch';
    return '';
  }

  function saveBuild(root, session) {
    if (!session || !session.saveBuild) return;
    session.saveBuild('traditional', {
      mode: root.dataset.productFamily === 'traditional-fi' ? 'fi' : 'standard',
      productHandle: root.dataset.productHandle || '',
      neck: root.dataset.neck || '',
      size: root.dataset.sizeValue || '',
      webbingWidth: constructionWidth(root),
      fiSeries: root.dataset.savedFiSeries || '',
      nativeFiSeries: root.dataset.nativeFiSeries || '',
      color: root.dataset.colorValue || '',
      guided: isGuided()
    });
  }

  function updateFit(root, session) {
    if (window.EDGSizing && window.EDGSizing.update(root, session)) return;
    const input = $(root, '[data-neck]');
    const neck = Number(input && input.value);
    const result = $(root, '[data-size-result]');
    $$(root, '[data-size-choice]').forEach(button => { button.hidden = true; button.classList.remove('is-selected'); });
    root.dataset.sizeValue = '';
    if (!neck || neck <= 0) {
      show(result, false);
      return;
    }

    root.dataset.neck = pretty(neck);
    if (session && session.saveMeasurement) session.saveMeasurement('neck', pretty(neck));
    const recommendation = recommendedSize(root, neck);
    if (!recommendation) {
      show(result, false);
      return;
    }

    const button = recommendation.button;
    button.hidden = false;
    show(result, true);
    setText(root, '[data-size-result-label]', button.dataset.nativeValue);
    if (recommendation.custom) {
      setText(root, '[data-size-result-note]', 'This measurement falls outside the published standard ranges, so the custom-size follow-up is the correct path.');
    } else if (recommendation.overlap) {
      setText(root, '[data-size-result-note]', 'This measurement sits in an overlap. EDG recommends the larger matching published size.');
    } else {
      setText(root, '[data-size-result-note]', 'This is the published buckle-collar range that contains the neck measurement.');
    }
    saveBuild(root, session);
  }

  function savedFiKind(value) {
    const v = String(value || '').toLowerCase();
    if (!v) return '';
    if (v.includes('mini')) return 'mini';
    if (v.includes('2')) return '2';
    if (v.includes('3+')) return '3plus';
    if (v.includes('3')) return '3';
    return '';
  }

  function prepareFiChoices(root, session) {
    const dog = !new URLSearchParams(location.search).has('edg_edit') && session && session.activeDog ? session.activeDog() : null;
    const savedFi = dog && dog.fiStatus === 'yes' ? dog.fiSeries : '';
    root.dataset.savedFiSeries = savedFi || '';
    const kind = savedFiKind(savedFi);
    const buttons = $$(root, '[data-fi-native-choice]');
    const question = $(root, '[data-fi-construction-question]');

    if (kind === 'mini') {
      show($(root, '[data-fi-mini-route]'), true);
      show($(root, '[data-traditional-guided]'), false);
      return false;
    }

    if (kind === '2') {
      buttons.forEach(button => { button.hidden = !/Series 2/i.test(button.dataset.nativeValue || ''); });
      if (question) question.textContent = question.dataset.fiWidthPrompt.replace('[model]', savedFi || 'Fi Series 2');
      const fi2 = buttons.find(button => /Series 2/i.test(button.dataset.nativeValue || ''));
      if (fi2) {
        applyNative(fi2.dataset.nativeOption, fi2.dataset.nativeValue);
        root.dataset.nativeFiSeries = fi2.dataset.nativeValue;
        fi2.classList.add('is-selected');
        fi2.hidden = true;
        show($(root, '[data-fi2-width]'), true);
      }
      return true;
    }

    if (kind === '3' || kind === '3plus') {
      buttons.forEach(button => { button.hidden = !/3\/3\+/i.test(button.dataset.nativeValue || ''); });
      if (question) question.textContent = question.dataset.fiWidthPrompt.replace('[model]', savedFi);
      return true;
    }

    buttons.forEach(button => { button.hidden = false; });
    if (question) question.textContent = question.dataset.fiPrompt;
    return true;
  }

  function filterColors(root) {
    const select = $(root, '[data-color-select]');
    if (!select) return;
    const width = constructionWidth(root);
    Array.from(select.options).forEach(option => {
      if (!option.value) return;
      const restricted = /1 inch only/i.test(option.value);
      option.disabled = restricted && width === '3/4 inch';
      option.hidden = option.disabled;
    });
    if (select.value && select.options[select.selectedIndex] && select.options[select.selectedIndex].disabled) {
      select.value = '';
      root.dataset.colorValue = '';
    }
  }

  function constructionComplete(root, session, advance) {
    filterColors(root);
    const isFi = root.dataset.productFamily === 'traditional-fi';
    const width = constructionWidth(root);
    const nativeFi = root.dataset.nativeFiSeries || '';
    if (isFi && (!nativeFi || (/Series 2/i.test(nativeFi) && !width))) return false;
    if (!isFi && !width) return false;
    setText(root, '[data-step-summary="construction"]', isFi ? fiWebbingSummary(root, root.dataset.savedFiSeries || nativeFi, width) : width);
    setStep(root, 'construction', advance ? 'complete' : 'active');
    setStep(root, 'color', advance ? 'active' : 'locked');
    setStep(root, 'addons', 'locked'); setStep(root, 'review', 'locked');
    saveBuild(root, session);
    if (advance) focusActiveStep(root);
    return true;
  }

  function updateReview(root) {
    const isFi = root.dataset.productFamily === 'traditional-fi';
    const dogName = root.dataset.dogName || 'Your dog';
    const width = constructionWidth(root);
    setText(root, '[data-review-dog]', dogName);
    setText(root, '[data-review-neck]', (root.dataset.neck || '') + ' in');
    setText(root, '[data-review-size]', root.dataset.sizeValue || '');
    setText(root, '[data-review-construction]', isFi ? fiWebbingSummary(root, root.dataset.savedFiSeries || root.dataset.nativeFiSeries, width) : width);
    setText(root, '[data-review-color]', root.dataset.colorValue || '');
  }

  function injectProperty(form, name, value) {
    if (!form || !name || value == null || value === '') return;
    let input = form.querySelector('input[data-edg-traditional-property][name="properties[' + name.replace(/"/g, '\\"') + ']"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.setAttribute('data-edg-traditional-property', 'true');
      input.name = 'properties[' + name + ']';
      form.appendChild(input);
    }
    input.value = value;
  }

  function nativeSelectionsMatch(root) {
    if (!root.dataset.sizeOption || nativeSelected(root.dataset.sizeOption) !== (root.dataset.sizeValue || '')) return false;
    if (!root.dataset.colorOption || nativeSelected(root.dataset.colorOption) !== (root.dataset.colorValue || '')) return false;
    if (root.dataset.productFamily === 'traditional-standard') {
      return !!root.dataset.widthOption && nativeSelected(root.dataset.widthOption) === (root.dataset.webbingWidth || '');
    }
    return !!root.dataset.fiOption && nativeSelected(root.dataset.fiOption) === (root.dataset.nativeFiSeries || '');
  }

  function waitForNative(root, timeout) {
    return new Promise(resolve => {
      const start = Date.now();
      function check() {
        const form = preferredProductForm(root);
        const variant = form && form.querySelector('input[name="id"]');
        if (nativeSelectionsMatch(root) && variant && variant.value) return resolve(form);
        if (Date.now() - start >= timeout) return resolve(null);
        setTimeout(check, 100);
      }
      check();
    });
  }

  async function submitBuild(root, session) {
    if (window.EDGSizing && !window.EDGSizing.validate(root)) return;
    setStatus(root, 'Checking the selected collar…');
    const button = $(root, '[data-ready-to-cart]');
    if ((!window.EDGSizing?.isKnown(root) && !root.dataset.neck) || !root.dataset.sizeValue || !root.dataset.colorValue || !constructionWidth(root)) {
      setStatus(root, 'Complete fit, construction, and color first.', 'error');
      return;
    }
    button.disabled = true;
    const exact = window.EDGCheckoutIntegrity && await window.EDGCheckoutIntegrity.waitForExact(root, 4000);
    const form = exact ? preferredProductForm(root) : null;
    if (!form) {
      button.disabled = false;
      setStatus(root, 'Eurus could not confirm the exact native Shopify variant. Re-select the last choice and try again.', 'error');
      return;
    }

    const dog = !new URLSearchParams(location.search).has('edg_edit') && session && session.activeDog ? session.activeDog() : null;
    injectProperty(form, 'Dog name', dog && dog.name ? dog.name : '');
    injectProperty(form, 'Dog neck', root.dataset.neck + ' in');
    injectProperty(form, 'EDG guided size', root.dataset.sizeValue);
    injectProperty(form, 'Size selection', window.EDGSizing ? window.EDGSizing.method(root) : 'Size recommendation');
    injectProperty(form, 'Webbing width', constructionWidth(root));
    if (root.dataset.productFamily === 'traditional-fi') {
      injectProperty(form, 'Fi setup', root.dataset.savedFiSeries || root.dataset.nativeFiSeries);
      injectProperty(form, 'Fi collar configuration', root.dataset.nativeFiSeries);
    }
    injectProperty(form, '_EDG Config Version', 'guided-traditional-v1');
    injectProperty(form, '_EDG Entry Path', 'Guided selector');
    saveBuild(root, session);

    const anchorToggle = root.querySelector('[data-edg-anchor-toggle]');
    injectProperty(form, 'ID Anchor', anchorToggle && anchorToggle.checked ? 'Yes' : 'No');
    try {
      const properties = {};
      for (const [key, value] of new FormData(form)) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      }
      const id = Number(form.querySelector('input[name="id"]').value);
      const items = window.EDGBuildCommerce.withIdAnchor(root, {id, quantity: 1, properties});
      const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      button.textContent = 'Adding collar…';
      await window.EDGBuildEditor.submit(root, items);
      window.location.assign(base + 'cart');
    } catch (error) {
      button.disabled = false;
      button.textContent=window.EDGBuildEditor.label(root)||'Add this collar to cart';
      setStatus(root, error.message || 'The collar could not be added.', 'error');
    }
  }

  function scrollToNative(root) {
    const container = document.querySelector('.variant-selects-main') || preferredProductForm(root);
    if (container) container.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function reuseChosenColor(root, session) {
    const dog=session&&session.activeDog?session.activeDog():null;
    const chosen=root.dataset.preferredColor||(dog&&dog.preferredColor)||'';
    if(!chosen)return false;
    root.dataset.preferredColor=chosen;
    const select=$(root,'[data-color-select]');
    if(!select)return false;
    const normalize=value=>String(value||'').toLowerCase().replace(/\([^)]*\)/g,'').replace(/1[- ]inch styles/g,'').replace(/[^a-z]/g,'');
    const option=Array.from(select.options).find(item=>item.value&&normalize(item.value)===normalize(chosen));
    const stringsNode=document.querySelector('[data-edg-color-strings]');
    const strings=stringsNode?JSON.parse(stringsNode.textContent):{};
    if(!option||option.disabled||option.hidden){
      if(strings.unavailable)setStatus(root,strings.unavailable,'error');
      return false;
    }
    select.value=option.value;
    select.dispatchEvent(new Event('change',{bubbles:true}));
    if(typeof syncSwatches==='function')syncSwatches(root);
    if(root.dataset.colorValue===option.value){if(strings.saved)setStatus(root,strings.saved,'success');return true;}
    return false;
  }
  function init(root, session) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    if (window.EDGSizing) window.EDGSizing.mount(root, { fit: () => updateFit(root, session), review: () => updateReview(root), save: () => saveBuild(root, session), construction: () => constructionComplete(root, session, true) });
    const dog = session.activeDog ? session.activeDog() : null;
    const name = dog && dog.name ? dog.name : 'your dog';
    const savedFi = dog && dog.fiStatus === 'yes' ? dog.fiSeries : '';
    const isFiProduct = root.dataset.productFamily === 'traditional-fi';
    const guided = isGuided();

    root.dataset.dogName = dog && dog.name ? dog.name : 'Your dog';
    root.dataset.savedFiSeries = savedFi || '';
    setText(root, '[data-builder-title]', root.dataset.layoutTitle || `Let’s build ${name === 'your dog' ? 'your' : name + '’s'} Traditional Buckle Collar.`);

    const sizeButton = $(root, '[data-size-choice]');
    if (sizeButton) root.dataset.sizeOption = sizeButton.dataset.nativeOption || 'size';
    const colorOption = $(root, '[data-color-select] option[data-native-option]');
    if (colorOption) root.dataset.colorOption = colorOption.dataset.nativeOption || 'color';
    const widthButton = $(root, '[data-width-choice]');
    if (widthButton) root.dataset.widthOption = widthButton.dataset.nativeOption || 'webbing-width';
    const fiButton = $(root, '[data-fi-native-choice]');
    if (fiButton) root.dataset.fiOption = fiButton.dataset.nativeOption || 'fi-series';

    if (savedFi) {
      const forFi = $(root, '[data-build-for-fi]');
      if (forFi) {
        const strong = forFi.querySelector('strong');
        if (strong) strong.textContent = 'Yes — build for ' + savedFi;
      }
    }

    if (guided) {
      document.documentElement.classList.add('edg-traditional-guided-active');
      show($(root, '[data-traditional-fi-branch]'), false);
      show($(root, '[data-direct-handoff]'), false);
      show($(root, '[data-traditional-guided]'), true);
      session.patchActiveDog && session.patchActiveDog({ traditionalMode: isFiProduct ? 'fi' : 'standard' });
      if (isFiProduct && !prepareFiChoices(root, session)) return;
      const savedNeck = dog && dog.measurements ? Number(dog.measurements.neck) : 0;
      if (savedNeck > 0) {
        const input = $(root, '[data-neck]');
        if (input) input.value = pretty(savedNeck);
        updateFit(root, session);
      }
    } else {
      show($(root, '[data-traditional-fi-branch]'), true);
      show($(root, '[data-traditional-guided]'), false);
      show($(root, '[data-direct-handoff]'), false);
    }

    const neck = $(root, '[data-neck]');
    if (neck) neck.addEventListener('input', () => updateFit(root, session));

    $$(root, '[data-size-choice]').forEach(button => button.addEventListener('click', () => {
      if (!applyNative(button.dataset.nativeOption, button.dataset.nativeValue)) {
        setStatus(root, 'We could not apply that size to the current Eurus product selector.', 'error');
        return;
      }
      selectButton(button, $(root, '[data-size-choices]'));
      root.dataset.sizeValue = button.dataset.nativeValue;
      setText(root, '[data-step-summary="fit"]', (root.dataset.neck || '') + ' in · ' + root.dataset.sizeValue);
      setStep(root, 'fit', 'complete');
      setStep(root, 'construction', 'active');
      setStep(root, 'color', 'locked');
      setStep(root, 'addons', 'locked'); setStep(root, 'review', 'locked');
      focusActiveStep(root);
      saveBuild(root, session);
    }));

    $$(root, '[data-width-choice]').forEach(button => button.addEventListener('click', () => {
      if (!applyNative(button.dataset.nativeOption, button.dataset.nativeValue)) {
        setStatus(root, 'We could not apply that width to the current Eurus product selector.', 'error');
        return;
      }
      selectButton(button, $(root, '[data-standard-width-choices]'));
      root.dataset.webbingWidth = button.dataset.nativeValue;
      constructionComplete(root, session);
    }));


    root.addEventListener('edg:fi-selection', event => {
      const choice = event.detail;
      root.dataset.savedFiSeries = ''; root.dataset.nativeFiSeries = ''; root.dataset.webbingWidth = ''; root.dataset.colorValue = '';
      const color = $(root, '[data-color-select]'); if (color) color.value = '';
      $$(root, '[data-color-choice]').forEach(button => { button.classList.remove('is-selected'); button.setAttribute('aria-pressed','false'); });
      setStep(root, 'construction', 'active'); setStep(root, 'color', 'locked'); setStep(root, 'addons', 'locked'); setStep(root, 'review', 'locked');
      setText(root, '[data-step-summary="construction"]', choice.modelLabel); setText(root, '[data-step-summary="color"]', '');
      choice.applied = true;
      if (!choice.value) { saveBuild(root, session); return; }
      if (!applyNative(choice.option, choice.value)) { choice.applied = false; return; }
      root.dataset.fiOption = choice.option; root.dataset.nativeFiSeries = choice.value; root.dataset.webbingWidth = choice.width;
      constructionComplete(root, session);
      document.dispatchEvent(new CustomEvent('eurus:variant:change'));
    });

    $$(root, '[data-fi-native-choice]').forEach(button => button.addEventListener('click', () => {
      if (!applyNative(button.dataset.nativeOption, button.dataset.nativeValue)) {
        setStatus(root, 'We could not apply that Fi configuration to the current Eurus product selector.', 'error');
        return;
      }
      selectButton(button, $(root, '[data-fi-native-choices]'));
      root.dataset.nativeFiSeries = button.dataset.nativeValue;
      if (/Series 2/i.test(button.dataset.nativeValue || '')) {
        show($(root, '[data-fi2-width]'), true);
        root.dataset.webbingWidth = '';
        filterColors(root);
      } else {
        show($(root, '[data-fi2-width]'), false);
        root.dataset.webbingWidth = constructionWidth(root);
        constructionComplete(root, session);
      }
    }));

    $$(root, '[data-fi2-width-choice]').forEach(button => button.addEventListener('click', () => {
      selectButton(button, button.parentElement);
      root.dataset.webbingWidth = button.dataset.fi2WidthChoice;
      constructionComplete(root, session);
    }));

    const colorSelect = $(root, '[data-color-select]');
    if (colorSelect) colorSelect.addEventListener('change', event => {
      const option = event.target.options[event.target.selectedIndex];
      if (!event.target.value) return;
      if (option.disabled) return;
      if (!applyNative(option.dataset.nativeOption || root.dataset.colorOption, event.target.value)) {
        setStatus(root, 'We could not apply that color to the current Eurus product selector.', 'error');
        return;
      }
      root.dataset.colorValue = event.target.value; root.dataset.preferredColor = event.target.value;
      setText(root, '[data-step-summary="color"]', event.target.value);
      setStep(root, 'color', 'complete');
      setStep(root, 'addons', 'active'); setStep(root, 'review', 'locked');
      updateReview(root);
      saveBuild(root, session);
    });

    $$(root, '[data-edit-step]').forEach(button => button.addEventListener('click', () => {
      if (!button.disabled) activateStep(root, button.dataset.editStep);
    }));

    const addButton = $(root, '[data-ready-to-cart]');
    if (addButton) addButton.addEventListener('click', () => submitBuild(root, session));
    const scrollButton = $(root, '[data-scroll-native]');
    if (scrollButton) scrollButton.addEventListener('click', () => scrollToNative(root));

    $$(root, '[data-traditional-mode]').forEach(button => button.addEventListener('click', () => {
      const mode = button.dataset.traditionalMode;
      selectButton(button, $(root, '[data-traditional-fi-branch]'));
      session.patchActiveDog && session.patchActiveDog({ traditionalMode: mode });
      session.saveBuild && session.saveBuild('traditional', { mode, productHandle: root.dataset.productHandle || '', guided: false });
      if (mode === 'standard' && isFiProduct) {
        window.location.assign(root.dataset.standardUrl + '?edg_mode=standard');
        return;
      }
      if (mode === 'fi' && !isFiProduct) {
        const suffix = savedFi ? '?edg_mode=fi&edg_fi=' + encodeURIComponent(savedFi) : '?edg_mode=fi';
        window.location.assign(root.dataset.fiUrl + suffix);
        return;
      }
      show($(root, '[data-direct-handoff]'), true);
      if (mode === 'fi' && savedFiKind(savedFi) === 'mini') {
        show($(root, '[data-fi-mini-route]'), true);
        show($(root, '[data-direct-handoff]'), false);
      }
    }));

    document.addEventListener('eurus:variant:change', () => filterColors(root));
  }

  function boot(attempt) {
    const root = document.querySelector('[data-edg-traditional-builder]');
    if (!root) return;
    const session = window.EDGBuildSession;
    if (!session) {
      if ((attempt || 0) < 40) setTimeout(() => boot((attempt || 0) + 1), 50);
      return;
    }
    init(root, session);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(0)); else boot(0);
  document.addEventListener('shopify:section:load', () => boot(0));
})();



